(() => {
  const salesEnabled = document.documentElement.dataset.salesEnabled === 'true';
  const moneyFormat = document.documentElement.dataset.moneyFormat || '£{{amount}}';
  const formatMoney = cents => moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  const MAX_QTY = 30;
  const clampQty = input => {
    const min = Number(input.min || 0);
    let value = parseInt(input.value, 10);
    if (Number.isNaN(value)) value = Math.max(min, 1);
    value = Math.max(min, Math.min(MAX_QTY, value));
    input.value = value;
    return value;
  };
  document.querySelectorAll('[data-qty-cap]').forEach(input => {
    if (input.name === 'updates[]') clampQty(input);
    input.addEventListener('change', () => clampQty(input));
    input.addEventListener('blur', () => clampQty(input));
  });
  document.querySelectorAll('[data-menu-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const drawer = document.getElementById(button.getAttribute('aria-controls'));
      const open = drawer.hasAttribute('hidden');
      drawer.toggleAttribute('hidden', !open);
      button.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-product-form]').forEach(form => {
    const variantData = form.querySelector('[data-variants-json]');
    const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
    const idInput = form.querySelector('[name="id"]');
    const priceOutput = form.querySelector('[data-product-price]');
    const addButton = form.querySelector('[data-add-button]');
    const status = form.querySelector('[data-variant-status]');
    const selectedOptions = () => [...form.querySelectorAll('[data-option-radio]:checked')].map(input => input.value);
    const updateVariant = () => {
      const choices = selectedOptions();
      const variant = choices.length ? variants.find(item => item.options.every((value, index) => value === choices[index])) : variants[0];
      if (!variant) { idInput.value = ''; if (addButton) addButton.disabled = true; if (status) status.textContent = 'This option combination is unavailable.'; return; }
      idInput.value = variant.id;
      if (priceOutput) priceOutput.textContent = formatMoney(variant.price);
      if (status) status.textContent = variant.available ? 'Available' : 'Currently unavailable';
      if (addButton && salesEnabled) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to bag' : 'Unavailable'; }
    };
    form.querySelectorAll('[data-option-radio]').forEach(input => input.addEventListener('change', updateVariant));
    updateVariant();
    form.addEventListener('submit', event => {
      if (!salesEnabled || !idInput.value || (addButton && addButton.disabled)) { event.preventDefault(); return; }
      if (form.dataset.capChecked === '1') return;
      const qtyInput = form.querySelector('[name="quantity"]');
      if (!qtyInput) return;
      event.preventDefault();
      const wanted = clampQty(qtyInput);
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(cart => {
        const inCart = (cart.items || []).filter(item => String(item.variant_id) === String(idInput.value)).reduce((sum, item) => sum + item.quantity, 0);
        const room = MAX_QTY - inCart;
        if (room <= 0) { const msg = status || document.querySelector('[data-variant-status]'); if (msg) msg.textContent = 'You already have the maximum of ' + MAX_QTY + ' of this item in your bag.'; return; }
        qtyInput.value = Math.min(wanted, room);
        form.dataset.capChecked = '1';
        form.submit();
      }).catch(() => { form.dataset.capChecked = '1'; form.submit(); });
    });
  });
  document.querySelectorAll('[data-quick-add]').forEach(form => {
    const button = form.querySelector('button');
    const msg = form.querySelector('[data-quick-msg]');
    const id = form.querySelector('[name="id"]').value;
    form.addEventListener('submit', event => {
      if (!salesEnabled) { event.preventDefault(); return; }
      if (!window.fetch) return;
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      const label = button.textContent;
      button.textContent = 'Adding...';
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(cart => {
        const inCart = (cart.items || []).filter(item => String(item.variant_id) === String(id)).reduce((sum, item) => sum + item.quantity, 0);
        if (inCart >= MAX_QTY) throw { capped: true };
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      }).then(r => { if (!r.ok) throw { failed: true }; return fetch('/cart.js', { headers: { Accept: 'application/json' } }); }).then(r => r.json()).then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => { el.textContent = cart.item_count; });
        button.textContent = 'Added to bag';
        button.classList.add('is-added');
        if (msg) msg.innerHTML = '<a href="/cart">View bag and checkout</a>';
        setTimeout(() => { button.textContent = label; button.classList.remove('is-added'); button.disabled = false; }, 2500);
      }).catch(err => {
        button.textContent = label; button.disabled = false;
        if (err && err.capped) { if (msg) msg.textContent = 'You already have the maximum of ' + MAX_QTY + ' in your bag.'; return; }
        form.submit();
      });
    });
  });
  /* v12_21: set and Mum card "add to bag" forms go through /cart/add.js so the Meta pixel and GA4 record AddToCart, then open the bag */
  document.querySelectorAll('form.mum-bundle__add, .mum-card__buy form').forEach(form => {
    form.addEventListener('submit', event => {
      if (!salesEnabled) { event.preventDefault(); return; }
      if (!window.fetch) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button) { if (button.disabled) return; button.disabled = true; button.textContent = 'Adding...'; }
      const ids = [...form.querySelectorAll('[name="items[][id]"], [name="id"]')].map(i => Number(i.value)).filter(Boolean);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(id => ({ id: id, quantity: 1 })) }) })
        .then(r => { if (!r.ok) throw new Error('add'); setTimeout(() => { window.location.href = '/cart'; }, 400); })
        .catch(() => { form.submit(); });
    });
  });
  document.querySelectorAll('[data-cart-form]').forEach(form => form.addEventListener('submit', event => { if (!salesEnabled && event.submitter && event.submitter.name === 'checkout') event.preventDefault(); }));
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (!track || slides.length < 2) return;
    let index = 0;
    let touchStartX = null;
    const select = next => {
      index = Math.max(0, Math.min(slides.length - 1, next));
      track.style.transform = `translateX(${-100 * index}%)`;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== index)));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-selected', String(i === index)));
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => select(Number(thumb.dataset.galleryThumb))));
    track.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', event => { if (touchStartX === null) return; const delta = event.changedTouches[0].clientX - touchStartX; if (Math.abs(delta) > 36) select(index + (delta < 0 ? 1 : -1)); touchStartX = null; }, { passive: true });
    gallery.addEventListener('keydown', event => { if (event.key === 'ArrowRight') { event.preventDefault(); select(index + 1); } if (event.key === 'ArrowLeft') { event.preventDefault(); select(index - 1); } });
    select(0);
  });
})();
